import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from "react";
import type { BerthCard_BerthFieldsFragment } from "@/client/graphql/types/generated";
type ContainerProps = {
  unloadingDocks: ReadonlyArray<BerthCard_BerthFieldsFragment>;
  cbFunc: (berthId: string) => void;
};
export const useContainer = t0 => {
  const $ = _c(8);
  const {
    unloadingDocks,
    cbFunc
  } = t0;
  const [disabled, setDisabled] = useState(false);
  let t1;
  if ($[0] !== cbFunc) {
    t1 = berthId => {
      setDisabled(true);
      cbFunc(berthId);
      setDisabled(false);
    };
    $[0] = cbFunc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClickCard = t1;
  let t2;
  if ($[2] !== unloadingDocks) {
    t2 = [...unloadingDocks].sort(_temp);
    $[2] = unloadingDocks;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sortedUnloadingDocks = t2;
  let t3;
  if ($[4] !== disabled || $[5] !== onClickCard || $[6] !== sortedUnloadingDocks) {
    t3 = {
      sortedUnloadingDocks,
      onClickCard,
      disabled
    };
    $[4] = disabled;
    $[5] = onClickCard;
    $[6] = sortedUnloadingDocks;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(a, b) {
  return a.sortOrder - b.sortOrder;
}